import { render } from "./ModalWithdrawOton.vue?vue&type=template&id=59180c66&scoped=true&ts=true"
import script from "./ModalWithdrawOton.vue?vue&type=script&lang=ts"
export * from "./ModalWithdrawOton.vue?vue&type=script&lang=ts"

import "./ModalWithdrawOton.vue?vue&type=style&index=0&id=59180c66&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59180c66"]])

export default __exports__